import React, { useState, useEffect } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';

import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTableV2';
import Button from 'components/CustomButtons/Button.js';
import VisibilityIcon from '@material-ui/icons/Visibility';
import CardIcon from 'components/Card/CardIcon';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core';

import { wsFindBy } from 'services/WService.js';
import { WithApp } from 'contexts/appContext';
import { Add, RecentActors } from '@material-ui/icons';
import FilterBusinessPartner from 'components/Tvendo/Common/FilterBusinessPartner';
import Badge from 'components/Badge/Badge';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

const useStyles = makeStyles({
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
  },
});

export default WithApp(function BusinessPartner({
  cardType,
  permissions,
  entity = 'base/business-partner',
}) {
  const classes = useStyles();
  const isCustomer = cardType === 'C' ? true : false;

  const columns = [
    { Header: '#', accessor: 'num', excelEnabled: false, width: 100 },
    { Header: 'Código', accessor: 'CardCode', width: 120 },
    {
      Header: `Nombre de ${isCustomer ? 'cliente' : 'proveedor'}`,
      accessor: 'CardName',
    },
    { Header: 'RUC/DNI', accessor: 'LicTradNum', width: 130, excelEnabled: false },
    { Header: 'SAP', accessor: 'SAPString', width: 130, hidden: true },
    { Header: 'SAP', accessor: 'SAP', width: 130, excelEnabled: false },
    { Header: 'Estado', accessor: 'state', width: 130 },
    { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
  ];

  const [bPartners, setBPartners] = useState([]);

  const [valueSearch, setValueSearch] = useState({});
  const [dataLoading, setDataLoading] = useState(false);

  /**
   * El codigo es C + 11 digitos, 12 en total. Si escribio solo numeros se
   * completa con ceros a la izquierda: 25 -> C00000000025.
   *
   * Solo para clientes: los proveedores empiezan con P, R, T o V, nunca con C.
   * Y solo si son todos digitos, para no pisar los 542 clientes cuyo codigo
   * arranca con S, E o R ni una busqueda parcial escrita a mano.
   */
  function completarCodigo(codigo) {
    const valor = (codigo || '').trim();

    if (!isCustomer || valor === '' || valor.length >= 12 || !/^[0-9]+$/.test(valor)) {
      return codigo;
    }

    return 'C' + valor.padStart(11, '0');
  }

  async function getBPartners(search) {
    const filtros = { ...search, CardCode: completarCodigo(search.CardCode) };

    for (var clave in filtros) {
      if (filtros[clave] == null || filtros[clave] === '') {
        delete filtros[clave]; //eliminamos solo las claves vacias
      }
    }
    setDataLoading(true);
    setBPartners([]);
    let response = await wsFindBy(entity, { ...filtros, CardType: cardType });
    setDataLoading(false);
    if (response.success) {
      setBPartners(response.data);
    }
  }

  useEffect(() => {
    getBPartners(valueSearch);
  }, []);

  return (
    <GridContainer>
      <GridItem xs={12}>
        <Card>
          <CardHeader icon>
            <AllowedGuard
              permission={permissions.store}
              component={
                <CardIcon color="primary">
                  <RecentActors style={{ color: 'white' }} />
                </CardIcon>
              }
            >
              <Link to={`${0}?type=${cardType}`}>
                <CardIcon pointer="true" color="success">
                  <Add style={{ color: 'white' }} />
                </CardIcon>
              </Link>
            </AllowedGuard>
            <h4 className={classes.cardIconTitle}>
              Listado de {isCustomer ? 'clientes' : 'proveedores'} {dataLoading && <LoadingSpinner />}
            </h4>
          </CardHeader>
          <CardBody>
            <GridContainer>
              <FilterBusinessPartner
                value={valueSearch}
                getValue={setValueSearch}
                getData={() => getBPartners(valueSearch)}
              />
            </GridContainer>
            <ReactTable
              excelName={isCustomer ? 'Clientes' : 'Proveedores'}
              defaultWidth={1000}
              columns={columns}
              data={bPartners.map((bPartner, i) => {
                return {
                  num: (
                    <div className="actions-right">
                      {i + 1}
                      <AllowedGuard permission={permissions.show}>
                        <Button justIcon round simple size="sm">
                          <Link to={`${bPartner.id}`}>
                            <VisibilityIcon />
                          </Link>
                        </Button>
                      </AllowedGuard>
                    </div>
                  ),
                  CardCode: bPartner.CardCode,
                  CardName: bPartner.CardName,
                  LicTradNum: bPartner.LicTradNum,
                  SAP:
                    bPartner.DocEntry === null ? (
                      <Badge color="danger">No migrado</Badge>
                    ) : (
                      <Badge color="success">Ok</Badge>
                    ),
                  SAPString: bPartner.DocEntry === null ? 'No migrado' : 'Ok',
                  state:
                    bPartner.completed === 'N'
                      ? 'Incompleto'
                      : bPartner.frozenFor === 'N'
                      ? 'Activo'
                      : 'Inactivo',
                  actions: '',
                };
              })}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
});
